import { Case } from 'dashboard/models/case';
import { RelatedReport, Report } from 'dashboard/models/report';
import { ReportRun } from 'dashboard/models/report-run';
import { ReportTemplate } from 'dashboard/models/report-template';
import { Tag } from 'dashboard/models/tag';
import Action from 'lib/interfaces/Action';

export type ReportActions =
  | Action<ReportActionType.ClearReport>
  | Action<ReportActionType.SetReport, SetReportPayload>
  | Action<ReportActionType.SetReportDetails, SetReportDetailsPayload>;

export enum ReportActionType {
  ClearReport = 'report/CLEAR_REPORT',
  SetReport = 'report/SET_REPORT',
  SetReportDetails = 'report/SET_REPORT_DETAILS',
}

export function clearReport(): Action<ReportActionType.ClearReport> {
  return { type: ReportActionType.ClearReport };
}

interface SetReportPayload {
  report: Report;
}

export function setReport(report: Report): Action<ReportActionType.SetReport, SetReportPayload> {
  return {
    payload: {
      report,
    },
    type: ReportActionType.SetReport,
  };
}

interface SetReportDetailsPayload {
  reportTemplate: ReportTemplate;
  tags: Tag[];
  cases: Case[];
  relatedReports: RelatedReport[];
  reportRuns?: ReportRun[];
}

export function setReportDetails({
  reportTemplate,
  tags,
  cases,
  relatedReports,
  reportRuns,
}: SetReportDetailsPayload): Action<ReportActionType.SetReportDetails, SetReportDetailsPayload> {
  return {
    payload: {
      reportTemplate,
      tags,
      cases,
      relatedReports,
      reportRuns,
    },
    type: ReportActionType.SetReportDetails,
  };
}
